import React, { createElement } from 'react';
import { getComponentClasses } from '@99designs/frontend-components/utils/app/index';

interface Props {
    type: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
    variations?: string[];
    children: React.ReactNode;
    style?: any;
}

const Heading = ({ type, variations, style, children }: Props) => {
    const className = getComponentClasses('heading', variations ? variations : []);
    return createElement(type, { className, style: style }, children);
};

export default Heading;
